import { render, staticRenderFns } from "./SortControl.vue?vue&type=template&id=7a86ceee&"
import script from "./SortControl.vue?vue&type=script&lang=ts&"
export * from "./SortControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports